import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  const handleBuyClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'The Nighttime Cortisol Code',
        content_ids: ['51859779191066'],
        content_type: 'product',
        value: 9.39,
        currency: 'USD'
      });
    }
    window.location.href = 'https://innershiftstore.com/cart/51859779191066:1';
  };
  return <section className="relative pt-32 pb-4 md:pt-40 md:pb-8 bg-cream overflow-hidden" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-111">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-112">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-113">
            <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-deep-teal font-bold text-sm mb-6 tracking-wide uppercase" data-id="element-114">
              For Women 40+
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-115">
              Woke Up at 3:00 AM Again? Why Your Body Is Storing Belly Fat While
              You Try to Sleep{' '}
              <span className="text-gold italic" data-id="element-116">
                (and How to Stop It Tonight).
              </span>
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-700 font-medium mb-8 leading-relaxed" data-id="element-117">
              The 7-Minute "Hormone Cooling" Protocol Designed Specifically for
              Women Over 40 Who Can't Lose Weight With Diet and Exercise Alone.
            </h2>

            <Button onClick={handleBuyClick} variant="primary" showArrow className="w-full sm:w-auto mb-8" data-id="element-118">
              Get My Cooling Code — $9.39
            </Button>

            <div className="space-y-4 text-gray-600 text-lg" data-id="element-119">
              <p data-id="element-120">
                You look in the mirror every morning and don't recognize your
                midsection anymore. You feel bloated, heavy, and above all,
                exhausted. You've done everything "right": you cut the carbs,
                you walked your 10,000 steps, and you took your supplements.
              </p>
              <p data-id="element-121">
                But the scale won't budge. Or worse, it's going up. It's not
                your lack of willpower. It's your{' '}
                <strong className="text-deep-teal" data-id="element-122">Midnight Cortisol</strong>{' '}
                telling your body you are in danger—forcing it to hoard belly
                fat to "survive" the stress.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-123">
            {/* Decorative background blur */}
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-90 -z-10" data-id="element-124"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png" alt="The Nighttime Cortisol Code eBook on Tablet and Phone" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-125" />
          </motion.div>
        </div>
      </div>
    </section>;
}